// @flow

import styled, { css } from "styled-components";
import buildColor from "../../_static/ColorPalette";

export const RunnerFlagsWrapper = styled.ul`
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;

  & .runner-flag {
    margin-right: 8px;

    &:last-of-type {
      margin-right: 0;
    }
  }
`;

export const ContentWrapper = styled.div`
  background-color: ${buildColor("white", "100")};
  padding: 12px;
  ${({ hasSeparator }) =>
    hasSeparator
      ? css`
          margin-top: 8px;
          border-top: 1px solid ${buildColor("blue", "100")};
        `
      : css`
          border-bottom: 1px solid ${buildColor("blue", "100")};
        `}
`;

export const IconWrapper = styled.span`
  margin-left: 4px;
  height: 24px;
  width: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const RunnerNumberContainer = styled.div`
  display: inline-block;
  width: 16px;
  height: 16px;
  margin-right: 4px;
`;
